import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import CurrencySelector from '../components/Withdraw/CurrencySelector';
import WalletsList from '../components/Withdraw/WalletsList';
import WithdrawForm from '../components/Withdraw/WithdrawForm';
import Multisend from '../components/Withdraw/Multisend';
import { getMerchantBalances } from '../redux/actions/merchantData';
import { getWithdrawWallets, getLoadMoreWithdrawWallets } from '../redux/actions/withdraw';
import useWindowSize from '../utils/resizeHook';
import { useLocation } from "react-router-dom";

const Withdraw = ({
  merchantId,
  networkFilter,
  merchantBalances,
  merchantData,
  balancesFetching,
  currencies,
  withdrawWallets,
  walletsFetching,
  getMerchantBalances,
  getWithdrawWallets,
  maxAmount,
  balancesTotal,
  getLoadMoreWithdrawWallets,
  page,
  countItem,
  pages
}) => {
  const [socket, setSocket] = useState(undefined);
  const [currency, setCurrency] = useState('');
  const [from, setFrom] = useState('');
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [to, setTo] = useState('');
  const [amount, setAmount] = useState('');
  const [multisendMode, setMultisendMode] = useState(false);
  const [walletVersionTick, setWalletVersionTick] = useState(0);
  const { currentWidth } = useWindowSize();

  const location = useLocation();
  useEffect(() => {
    const bump = () => setWalletVersionTick((n) => n + 1);
    const onStorage = (e) => {
      if (e.key === 'walletVersion') bump();
    };
    window.addEventListener('walletVersionChange', bump);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('walletVersionChange', bump);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  const merchantWalletVersion = merchantData?.settingWallet?.version;
  const effectiveWalletVersion = merchantWalletVersion
    ? (localStorage.getItem('walletVersion') || merchantWalletVersion)
    : undefined;

  useEffect(() => {
    if (location.pathname === '/multisend') {
      setMultisendMode(true)
    } else {
      setMultisendMode(false)
    }
  }, [location]);

  const walletListRef = useRef(null);

  useEffect(() => {
    walletListRef?.current && walletListRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [currency]);

  useEffect(() => {
    setCurrency('');
    setFrom('');
    setSelectedWallet(null);
    setTo('');
    setAmount('');

    if (merchantId && merchantWalletVersion) {
      getWithdrawWallets(merchantId, '', networkFilter, true, true, false, false, 1, effectiveWalletVersion);
    }
  }, [merchantId, networkFilter, effectiveWalletVersion, walletVersionTick, merchantWalletVersion]);

  useEffect(() => {
    if (merchantId) {
      if (from && selectedWallet) {
        const walletCurrencyId = selectedWallet?.currencyId || selectedWallet?.balances?.[0]?.currency?.id || '';

        getWithdrawWallets(
          merchantId,
          walletCurrencyId,
          networkFilter,
          true,
          true,
          false,
          false,
          1,
          effectiveWalletVersion
        );
        getWithdrawWallets(
          merchantId,
          walletCurrencyId,
          networkFilter,
          false,
          undefined,
          true,
          false,
          1,
          effectiveWalletVersion
        );
      } else {
        getWithdrawWallets(merchantId, currency, networkFilter, true, true, false, false, 1, effectiveWalletVersion);
      }
      if (!currency) window.scrollTo({ top: 0 });
    }
  }, [currency, merchantId, networkFilter, effectiveWalletVersion, walletVersionTick]);

  useEffect(() => {
    setAmount(maxAmount);
  }, [maxAmount]);

  useEffect(() => {
    socket && socket.disconnect();
    setSocket(undefined);
    createSocket(merchantId);
  }, [merchantId]);

  const createSocket = merchantId => {
    const io = window.io;
    const socket = io(process.env.REACT_APP_API_URL, {
      allowEIO3: true,
      withCredentials: true,
    });
    socket.on('connect', () => {
      socket.emit('sign-in-merchant', { token: localStorage.getItem('authToken'), merchantId });
      // setSocket(socket);
    });
    socket.on('updatedBalance', () => {
      if (merchantId) {
        console.log('getMerchantBalances called from Withdraw.jsx updatedBalance socket, merchantId:', merchantId, 'networkFilter:', networkFilter, 'walletVersion:', effectiveWalletVersion);
        getMerchantBalances(merchantId, networkFilter, true, false, effectiveWalletVersion);
        // getWithdrawWallets(merchantId, currency, networkFilter, true, true);
      }
    });
    socket.on('disconnect', function () {});
  };

  return !multisendMode ? (
    <>
      <Row gutter={[12, 0]}>
        {from ? (
          <Col span="24">
            <WithdrawForm
              merchantId={merchantId}
              currency={currency}
              networkFilter={networkFilter}
              setCurrency={setCurrency}
              currencies={currencies}
              from={from}
              setFrom={setFrom}
              to={to}
              setTo={setTo}
              amount={amount}
              setAmount={setAmount}
              selectedWallet={selectedWallet}
              setSelectedWallet={setSelectedWallet}
              getLoadMoreWithdrawWallets={getLoadMoreWithdrawWallets}
              walletVersion={effectiveWalletVersion}
            />
          </Col>
        ) : (
          <>
            <Col span={currentWidth >= 1024 ? 8 : 24}>
              <CurrencySelector
                merchantBalances={merchantBalances}
                balancesFetching={balancesFetching}
                currencies={currencies}
                currency={currency}
                setCurrency={setCurrency}
                balancesTotal={balancesTotal}
                getMerchantBalances={getMerchantBalances}
                merchantId={merchantId}
                networkFilter={networkFilter}
                walletVersion={effectiveWalletVersion}
              />
            </Col>
            <Col span={currentWidth >= 1024 ? 16 : 24}>
              <WalletsList
                withdrawWallets={withdrawWallets}
                walletsFetching={walletsFetching}
                selectedWallet={selectedWallet}
                setSelectedWallet={setSelectedWallet}
                from={from}
                setFrom={setFrom}
                setCurrency={setCurrency}
                multisendMode={multisendMode}
                setMultisendMode={setMultisendMode}
                walletListRef={walletListRef}
                currencies={currencies}
                currency={currency}
                getLoadMoreWithdrawWallets={getLoadMoreWithdrawWallets}
                walletVersion={effectiveWalletVersion}
                merchantId={merchantId}
                networkFilter={networkFilter}
                countItem={countItem}
                page={page}
                pages={pages}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  ) : (
    <Multisend />
  );
};

const mapStateToProps = state => ({
  merchantId: state.transactions.merchantId,
  networkFilter: state.networkFilter,
  merchantBalances: state.merchantData.balances.balances || [],
  merchantData: state.merchantData.data,
  balancesFetching: state.merchantData.fetching,
  currencies: state.currencies.data,
  withdrawWallets: state.withdraw.wallets.data,
  walletsFetching: state.withdraw.wallets.fetching,
  maxAmount: state.withdraw.maxAmount,
  balancesTotal: state.merchantData.balances.total,
  page: state.withdraw.wallets.page,
  pages: state.withdraw.wallets.pages,
  countItem: state.withdraw.wallets.countItem,
});

const mapDispatchToProps = dispatch => ({
  getMerchantBalances: getMerchantBalances(dispatch),
  getWithdrawWallets: getWithdrawWallets(dispatch),
  getLoadMoreWithdrawWallets: getLoadMoreWithdrawWallets(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Withdraw);
